<template>
  <div class="autocomplete">
    <Multiselect
      :id="`autocomplete${id}`"
      v-model="text"
      :options="dataList"
      :close-on-select="true"
      :show-labels="false"
      :show-no-results="false"
      :placeholder="placeholder"
      :label="label"
      :track-by="trackBy"
      :searchable="searchable"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

// FIXME このコンポーネントを使うコンポーネント内では.p-formGrid { overflow: visible; }をつけること
export default {
  name: 'Autocomplete',
  components: {
    Multiselect,
  },
  props: {
    id: {
      type: String,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    dataList: {
      type: Array, // String[] || Object[]
      required: true,
    },
    value: {
      type: [Object, String],
    },
    label: {
      type: String,
    },
    trackBy: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    }
  },
  emits: ['change'],
  computed: {
    text: {
      get() {
        return this.value
      },
      set(text) {
        this.$emit('change', text)
      },
    },
  }
}
</script>

<style lang="scss" scoped>
.autocomplete {
  position: relative;
  width: 100%;
}

:deep(.multiselect__tags) {
  position: relative;
  display: block;
  width: 100%;
  padding: 12px 48px 12px 16px;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  line-height: 1.5;

  &::-ms-expand {
    display: none;
  }

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 16px;
    z-index: 1;
    transform: translateY(-50%) rotate(180deg);
    width: 0;
    height: 0;
    border-width: 0 4px 4px;
    border-style: solid;
    border-color: transparent transparent #3a3b3f;
    pointer-events: none;
  }
}

:deep(.multiselect__content) {
  position: absolute;
  width: 100%;
  height: 200px;
  border: 1px solid #e4e7eb;
  border-radius: 4px;
  background-color: #fff;
  z-index: 2;
  overflow-y: scroll;
}

:deep(.multiselect__element) {
  width: 100%;
}

:deep(.multiselect__option) {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  padding: 8px;

  &:hover {
    background-color: #e4e7eb;
  }
}

:deep(.multiselect__option--disabled) {
  background: #ededed;
  color: #a6a6a6;
}
</style>
